<template>
  <div
    class="vote-country"
    :class="fadeClasses"
  >
    <img
      class="vc-boxes"
      alt=""
      draggable="false"
      :src="require('@/assets/images/end/boxes.svg')"
    />
    <div
      class="vc-people nl"
      :style="style"
    ></div>
    <div
      class="vc-people others others1"
      :style="style"
    ></div>
    <div
      class="vc-people others others2"
      :style="style"
    ></div>
    <div
      class="vc-people others others3"
      :style="style"
    ></div>
    <div
      class="vc-people others others4"
      :style="style"
    ></div>
  </div>
</template>

<script>
import { fadeMixin } from '@/mixins'
import { TimelineMax, Power0 } from 'gsap'

export default {
  name: 'VoteCountry',
  mixins: [fadeMixin],
  data () {
    return {
      style: {
        'background-image': `url(${require('@/assets/images/end/people.svg')})`
      }
    }
  },
  watch: {
    done () {
      const scene = this.$scrollmagic.scene({
        triggerElement: '.vote-country'
      })

      const timeline = new TimelineMax({ repeat: -1 })
        .to('.vc-people.nl', 10, {
          backgroundPosition: '-306px 0',
          ease: Power0.easeNone
        }, 0)
        .to('.vc-people.others', 10, {
          backgroundPosition: '-306px 0',
          ease: Power0.easeNone
        }, 5)

      this.$scrollmagic.addScene(
        scene.setTween(timeline)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.vote-country {
  position: relative;
  margin: 60px auto;
  text-align: center;
  width: 306px;
}

.vc-people {
  width: 306px;
  height: 44px;
  background-size: 306px 44px;
  background-position: 306px 0;
  background-repeat: no-repeat;
  position: absolute;
}

.nl {
  left: 50%;
  top: 80px;
  transform: translateX(23px);
}

.others {
  bottom: 9px;
}

.others1 {
  left: 27px;
}

.others2 {
  left: 124px;
}

.others3 {
  left: 218px;
}

.others4 {
  left: 306px;
}
</style>
